import Typography from '@/common/components/base/typography/Typography';
import { SwitchTabProps } from '@/modules/adjusterReportModules/IncidentParticipants/components/common/SwitchTab.type';
import React from 'react';
import { Box, Flex } from 'styled-system/jsx';

const SwitchTab: React.FC<SwitchTabProps> = ({
  activeTab,
  tabs,
  getActiveTab,
}) => {
  const [activeTabIndex, setActiveTabIndex] = React.useState(activeTab);
  const shouldSlide = tabs.length > 3;

  return (
    <Box bg="white" w="100%" p={8} borderRadius={16}>
      <Flex
        alignItems="center"
        justifyContent="flex-start"
        gap={24}
        overflowX={shouldSlide ? 'auto' : 'visible'}
        css={{
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {tabs.map((tab, index) => (
          <Box
            key={index}
            h={48}
            w={144}
            flexShrink={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flex={shouldSlide ? 'none' : 1}
            borderRadius={16}
            bg={activeTabIndex === tab.activeTabIndex ? 'purple-7' : 'white'}
            cursor="pointer"
            onClick={() => {
              setActiveTabIndex(tab.activeTabIndex);
              getActiveTab && getActiveTab(tab.activeTabIndex);
            }}
          >
            <Flex alignItems="center" gap={8}>
              <Box
                color={
                  activeTabIndex === tab.activeTabIndex
                    ? 'purple-primary'
                    : 'black-3'
                }
              >
                {tab.icon}
              </Box>
              <Typography
                textStyle="b2"
                color={
                  activeTabIndex === tab.activeTabIndex
                    ? 'purple-primary'
                    : 'black-2'
                }
              >
                {tab.title}
              </Typography>
            </Flex>
          </Box>
        ))}
      </Flex>
    </Box>
  );
};
export default SwitchTab;
